import type { MessageAttachment } from '@/types/conversations'

import { AudioAttachment } from './AudioAttachment'
import { DocumentAttachment } from './DocumentAttachment'
import { ImageAttachment } from './ImageAttachment'
import { LocationAttachment } from './LocationAttachment'
import { StickerAttachment } from './StickerAttachment'
import { VideoAttachment } from './VideoAttachment'
import type { AttachmentContext } from './attachmentContext'

export type { AttachmentContext } from './attachmentContext'

interface MessageAttachmentsProps {
  attachments: MessageAttachment[]
  attachmentContext?: AttachmentContext
}

export function MessageAttachments({
  attachments,
  attachmentContext = 'assistant',
}: MessageAttachmentsProps) {
  if (!attachments.length) {
    return null
  }

  return (
    <div className="mt-2 flex min-w-0 max-w-full flex-col gap-2">
      {attachments.map((attachment) => {
        switch (attachment.type) {
          case 'image':
            return (
              <ImageAttachment
                key={attachment.id}
                attachment={attachment}
                attachmentContext={attachmentContext}
              />
            )
          case 'audio':
            return (
              <AudioAttachment
                key={attachment.id}
                attachment={attachment}
                attachmentContext={attachmentContext}
              />
            )
          case 'video':
            return (
              <VideoAttachment
                key={attachment.id}
                attachment={attachment}
                attachmentContext={attachmentContext}
              />
            )
          case 'document':
            return (
              <DocumentAttachment
                key={attachment.id}
                attachment={attachment}
                attachmentContext={attachmentContext}
              />
            )
          case 'location':
            return <LocationAttachment key={attachment.id} attachment={attachment} />
          case 'sticker':
            return <StickerAttachment key={attachment.id} attachment={attachment} />
          default:
            return null
        }
      })}
    </div>
  )
}
